import React from 'react';

export default function ClientListSkeleton() {
  return (
    <div className="mt-8 space-y-4">
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="bg-white rounded-xl shadow-md p-6 animate-pulse"
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex-1 space-y-3">
              <div className="h-6 w-48 bg-slate-300 rounded"></div>
              <div className="h-4 w-64 bg-slate-200 rounded"></div>
              <div className="h-4 w-40 bg-slate-200 rounded"></div>
            </div>
            <div className="h-11 w-32 bg-blue-200 rounded-xl"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
